document.addEventListener("DOMContentLoaded", function () {
 const wrapper = document.querySelector('[id^="Slider-"]');
 const nextBtn = document.getElementById("nextBtn");
 const prevBtn = document.getElementById("prevBtn");
 const boxesPerPage = window.columns_desktop;
 let currentIndex = 0;

 function updateVisibleBoxes() {
  const boxes = wrapper.children;
  for (let i = 0; i < boxes.length; i++) {
   if (i >= currentIndex && i < currentIndex + boxesPerPage) {
    boxes[i].style.display = "block";
   } else {
    boxes[i].style.display = "none";
   }
  }
  updatePagination();
  updateButtons();
 }

 function updatePagination() {
  const totalBoxes = wrapper.children.length;
  const totalPages = Math.ceil(totalBoxes / boxesPerPage);
  for (let i = 0; i < totalPages; i++) {
   const pageNumber = document.createElement("span");
   pageNumber.classList.add("page-number");
   if (i === currentIndex / boxesPerPage) {
    pageNumber.classList.add("active");
   }
   pageNumber.textContent = i + 1;
   pageNumber.addEventListener("click", () => {
    currentIndex = i * boxesPerPage;
    updateVisibleBoxes();
   });
  }
 }

 function updateButtons() {
  prevBtn.disabled = currentIndex === 0;
  nextBtn.disabled = currentIndex + boxesPerPage >= wrapper.children.length;
 }

 nextBtn.addEventListener("click", () => {
  if (currentIndex + boxesPerPage < wrapper.children.length - window.columns_desktop) {
   currentIndex += boxesPerPage;
   updateVisibleBoxes();
  }
 });

 prevBtn.addEventListener("click", () => {
  if (currentIndex - boxesPerPage >= 0) {
   currentIndex -= boxesPerPage;
   updateVisibleBoxes();
  }
 });

 updateVisibleBoxes();
});
